import type { TimelineSnapshot } from "../../types/burndown.types";

/** Stable key so parent views refresh when snapshot content changes, not only the date. */
export function getSnapshotNotificationKey(
  snapshot: TimelineSnapshot,
): string {
  const expenseKey = (snapshot.activeExpenses || [])
    .map(
      (expense) =>
        `${expense.id}:${expense.isOneTime ? "1" : "0"}:${expense.oneTimeAmount ?? ""}:${expense.monthlyAmount ?? ""}`,
    )
    .sort()
    .join("|");

  const revenueKey = (snapshot.activeRevenues || [])
    .map((revenue) => `${revenue.id}:${revenue.monthlyAmount ?? ""}`)
    .sort()
    .join("|");

  return [
    snapshot.date.getTime(),
    snapshot.cashBalance,
    snapshot.monthlyBurn,
    snapshot.monthlyRevenue,
    snapshot.netMonthlyChange,
    expenseKey,
    revenueKey,
  ].join("::");
}
